import { render, staticRenderFns } from "./HelpCreate.vue?vue&type=template&id=252cb958"
import script from "./HelpCreate.vue?vue&type=script&lang=js"
export * from "./HelpCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports